module.exports = __webpack_public_path__ + "img/catchbasin_stopped.c092a50e.svg";